import { getToken } from './session'

// Always returns an Authorization header so the axios interceptor (http.js)
// can recognise authenticated requests: with no token it cancels them instead
// of sending a request that is guaranteed to 401.
export default function authHeader() {
  return { Authorization: 'Bearer ' + (getToken() || '') };
}
